/**
 * branding.service.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Title } from "@angular/platform-browser";
import { AlgorithmService } from "app/algorithms/management/algorithm.service";
import { RunningAlgorithm } from "app/algorithms/structure/running-algorithm";
import { SettingService } from "app/configuration/setting.service";
import { BehaviorSubject } from "rxjs/Rx";

@Injectable()
export class BrandingService
{
  private static readonly FLAGS_LABEL : string = "FLAGS";

  public strings : {[key : string] : string} = {};

  public flags : Set<string> = new Set();

  public done : BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor (
    protected http : Http,
    protected title : Title,
    protected algorithms : AlgorithmService,
    protected settings : SettingService
  )
  {
    this.http.request("/zone/brand_strings.json").subscribe(
      (response : Response) => {
        const loaded : any = response.json();
        for (const key of Object.keys(loaded))
        {
          if (key === BrandingService.FLAGS_LABEL)
          {
            if (!Array.isArray(loaded[key]))
            {
              console.error(key, loaded);
              throw new Error(`FLAGS values was not an array ${loaded[key]}`);
            }
            loaded[key].forEach(
              (item : any) => this.flags.add(`${item}`));
          }
          else {
            if (typeof loaded[key] !== "string")
            {
              console.error(key, loaded);
              throw new Error(`Found non-string value in map: ${loaded[key]}`);
            }
            this.strings[key] = loaded[key];
          }
        }
        this.done.next(true);
      });

      if (this.settings.getOr("use dynamic titles", false))
      {
        this.algorithms.runningObservable.subscribe((ra : RunningAlgorithm) => {
          if (ra)
          {
            this.setTitle("Advocus: " + ra.subject.abbreviatedTitle);
          }
          else
          {
            this.resetTitle();
          }
        });
      }
  }

  private readonly defaultTitle : string = "Advocus";

  public setTitle (newTitle : string) : void
  {
    this.title.setTitle(newTitle);
  }

  public resetTitle () : void
  {
    this.title.setTitle(this.defaultTitle);
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/branding.service.ts